export default __webpack_public_path__ + "static/media/logo.496dec70.png";